import {Directive, ElementRef, HostListener, OnInit} from '@angular/core';
import {Table} from 'primeng/table';

/**
 * Directive nous permettant d'ajouter le déplacement sur les lignes avec le clavier
 */
@Directive({
	standalone: true,
	selector: 'p-table[tableKeysDirective]'
})
export class TableKeysDirective implements OnInit {

	constructor(private table: Table, private el: ElementRef<HTMLElement>) {}

	ngOnInit() {
		this.el.nativeElement.tabIndex = 1;
	}

	@HostListener('keydown.ArrowUp', ['$event']) ArrowUp($event: KeyboardEvent) {
		if (!this.table.el.nativeElement.querySelector('tbody tr app-autocomplete input.open')) {
			const inputName = this.getInputNameSelectionne();
			this.table.selection = this.navigateItem(-1);
			this.setFocus(inputName);
			this.table.onRowSelect.emit({originalEvent: $event, data: this.table.selection, type: 'row'});
			event.preventDefault();
		}
	}

	@HostListener('keydown.ArrowDown', ['$event']) ArrowDown($event: KeyboardEvent) {
		if (!this.table.el.nativeElement.querySelector('tbody tr app-autocomplete input.open')) {
			const inputName = this.getInputNameSelectionne();
			this.table.selection = this.navigateItem(1);
			this.setFocus(inputName);
			this.table.onRowSelect.emit({originalEvent: $event, data: this.table.selection, type: 'row'});
			event.preventDefault();
		}
	}

	/**
	 * @Return le nom de l'input sélectionné. Undefined sinon
	 */
	getInputNameSelectionne(): string {
		if (this.table.selection) {
			const i = this.table.value.indexOf(this.table.selection);
			if (i > -1) {
				const lignes = this.table.el.nativeElement.querySelectorAll('tbody tr');
				if (lignes && lignes[i]) {
					// On recherche si un input avec focus existe
					const input = lignes[i].querySelector('input:focus');
					if (input && input.name) {
						return input.name;
					}
					// on en a pas trouvé, on va chercher un éventuel autocomplete
					const autoComplete = lignes[i].querySelector('app-autocomplete');
					if (autoComplete && autoComplete.querySelector('input:focus') && autoComplete.attributes['ng-reflect-name']) {
						return autoComplete.attributes['ng-reflect-name'].value;
					}
				}
			}
		}
		return undefined;
	}

	navigateItem(num) {
		if (!this.table.selection) { return; }
		const i = this.table.value.indexOf(this.table.selection);
		const len = this.table.value.length;
		if (num > 0) {
			return this.table.value[(i + num) % len];
		}
		return this.table.value[(i + len + num) % len];
	}

	setFocus(nomInput: string) {
		const i = this.table.value.indexOf(this.table.selection);
		if (i > -1) {
			const lignes = this.table.el.nativeElement.querySelectorAll('tbody tr');
			if (lignes && lignes[i]) {
				let input;
				if (nomInput) {
					input = lignes[i].querySelector('input[name=\'' + nomInput + '\'], app-autocomplete[ng-reflect-name=\'' + nomInput + '\'] input');
				}
				else {
					input = lignes[i].querySelector('input');
				}
				if (input) {
					setTimeout(() => {
						input.focus();
					}, 100);
				}
			}
		}
	}
}
